import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert, Card } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Base_URL } from "../url";
import { FaInfoCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const DocumentDetailsScreen = () => {
  const { zCode } = useParams();
const navigate = useNavigate();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchDocuments();
  }, [zCode]);

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${Base_URL}/DocumentPostings/GetAllDocuments/${zCode}`
      );
      setDocuments(response.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch documents");
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <Card className="shadow-sm">
        <Card.Body>
          <h4 className="mb-3">Document Details ({zCode})</h4>

          {loading && (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          )}

          {error && <Alert variant="danger">{error}</Alert>}

          {!loading && !error && (
            <Table bordered hover responsive>
             <thead>
  <tr>
    <th>#</th>
    <th>Doc No</th>
    <th>FY</th>
    <th>FM</th>
    <th>Document Date</th>
    <th>Info</th>
  </tr>
</thead>
<tbody>
  {documents.length > 0 ? (
    documents.map((doc, index) => (
      <tr key={doc.id}>
        <td>{index + 1}</td>
        <td>{doc.docno}</td>
        <td>{doc.docfy}</td>
        <td>{doc.docfm}</td>
        <td>
          {new Date(doc.documentDate).toLocaleDateString()}
        </td>
        <td className="text-center">
          <FaInfoCircle
            style={{ cursor: "pointer", color: "#0d6efd" }}
            onClick={() =>
              navigate(`/document-info/${doc.refNo}`)
            }
            title="View Details"
          />
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center">
        No documents found
      </td>
    </tr>
  )}
</tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default DocumentDetailsScreen;